
import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent } from "@/components/ui/card";
import { Image } from "lucide-react";

interface ContentVisualizationGalleryProps {
  visualizations: {
    concept: string;
    imageUrl: string;
  }[];
}

export const ContentVisualizationGallery: React.FC<ContentVisualizationGalleryProps> = ({
  visualizations
}) => {
  if (visualizations.length === 0) return null;

  return (
    <div className="space-y-4">
      {visualizations.length === 1 ? (
        <div className="space-y-2">
          <h4 className="text-sm font-medium">{visualizations[0].concept}</h4>
          <div className="rounded-lg overflow-hidden border bg-white">
            <img 
              src={visualizations[0].imageUrl} 
              alt={`Visual representation of ${visualizations[0].concept}`}
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      ) : (
        <ScrollArea className="w-full whitespace-nowrap pb-2">
          <div className="flex space-x-4 pb-4">
            {visualizations.map((visual, i) => (
              <Card key={i} className="min-w-[260px] overflow-hidden flex-shrink-0">
                <CardContent className="p-0">
                  <div className="p-2 bg-muted/20">
                    <h4 className="text-sm font-medium truncate">{visual.concept}</h4>
                  </div>
                  <div className="relative h-[180px] bg-white/40">
                    {visual.imageUrl ? (
                      <img 
                        src={visual.imageUrl} 
                        alt={`Visual representation of ${visual.concept}`}
                        className="w-full h-full object-contain"
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <Image className="h-8 w-8 text-muted" />
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  );
};
